(function () {
	const resetFormButtons = document.querySelectorAll('.js-clear');
	if (!resetFormButtons) return;
	resetFormButtons.forEach((button) => {
		const form = button.closest('form');
		// if the form values are blank, hide the button
		// otherwise show it
		const checkFormValues = () => {
			const inputs = form.querySelectorAll(
				'input:not([type="radio"]):not([type="checkbox"]):not(.filter-long-list__search-field)',
			);
			const radio_checkboxes = form.querySelectorAll('input:checked');
			const textareas = form.querySelectorAll('textarea');
			const selects = form.querySelectorAll('select:not(.js-ignore-clear)');

			const values = [...inputs, ...radio_checkboxes, ...textareas, ...selects].map(
				(input) => input.value,
			);

			const isBlank = values.every((value) => value === '');
			button.classList.toggle('hidden-clear', isBlank);
		};

		checkFormValues();

		// check the form values on change
		form.querySelectorAll('input, select:not(.js-ignore-clear), textarea').forEach((input) => {
			input.addEventListener('input', checkFormValues);
		});

		// when the button is clicked
		// we want to clear the whole form, not just reset it
		button.addEventListener('click', (e) => {
			e.preventDefault();

			const inputs = form.querySelectorAll(
				'input:not([type="radio"]):not([type="checkbox"]):not(.filter-long-list__search-field)',
			);
			const radio_checkboxes = form.querySelectorAll('input:checked');
			const textareas = form.querySelectorAll('textarea');
			const selects = form.querySelectorAll('select:not(.js-ignore-clear)');

			inputs.forEach((textarea) => {
				textarea.value = '';
			});

			radio_checkboxes.forEach((input) => {
				input.checked = false;
			});

			textareas.forEach((textarea) => {
				textarea.value = '';
			});

			selects.forEach((select) => {
				select.value = '';
			});

			// trigger an on change event for each individual input by name
			// this is needed to update the UI
			const names = [];
			[...radio_checkboxes, ...selects].forEach((input) => {
				if (names.indexOf(input.name) === -1) {
					names.push(input.name);
					input.dispatchEvent(new Event('change'));
				}
			});
			[...inputs, ...textareas].forEach((input) => {
				if (names.indexOf(input.name) === -1) {
					names.push(input.name);
					input.dispatchEvent(new Event('input'));
				}
			});

			checkFormValues();
		});
	});
})();
